import { INotifications } from '../../../shared/interfaces/notifications/INotifications';
import { IBaseModel } from '../../../shared/interfaces/shared/IBase';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { requests } from '../../../utils/api/api.service';
import { NOTIFICATION_URL } from '../../../utils/api/endpoints';

export const AdminNotificationService = {
  getAll: (pagination: IPagination): Promise<IBaseModel<INotifications[]>> =>
    requests.get(NOTIFICATION_URL, pagination),
  clearNotification: (id: number) =>
    requests.put(`${NOTIFICATION_URL}/mark-read/${id}`, {}),
  clearAllNotifications: () =>
    requests.put(`${NOTIFICATION_URL}/mark-all-read`, {}),
  delete: (id: number) => requests.delete(`${NOTIFICATION_URL}/${id}`),
};
